import React, { Component } from 'react';
import Utils from '../../utils';

const disallowedPaths = [
	"/",
	"/retirement/?",
	"/retirement/v\\d/?",
	"/retirement/v\\d/contracts/?",
	"/retirement/v\\d/participants/?"
];

const occurrences = (needle, haystack) => {
	return (haystack.match(new RegExp(needle, "gi")) || []).length;
}

const returnPlaceholders = (path) => {
	return new Set((path.match(/\{[^}]*}/g) || []).map(s => s.replace("{", "").replace("}", "")));
}

const areSetsEqual = (setA, setB) => {
	return (setA.size === setB.size && [...setA].every(value =>setB.has(value)));
}

class RoutingLiberty extends Component {

	constructor(props) {
		super(props);
		this.state = {
			proxyPathError: false,
			usefulProxy: null,
			allProxies: [],
		};
	}

	isValidated = async () => {
		let virtualPath = this.props.getStore().virtualPath;
		let targetPath = this.props.getStore().targetPath;
		await this.proxyVirtualAndTargetPathExists(this.props.getStore().virtualPath + "/" , this.props.getStore().targetPath + "/");

		return !this.validatePath(virtualPath)
			&& !this.validatePath(targetPath)
			&& !this.validatePathVariables(virtualPath, targetPath)
			&& !this.state.proxyPathError;
	};

	proxyVirtualAndTargetPathExists = async (virtualPath, targetPath) => {

		if(this.state.allProxies.length === 0){
			try {
				const apiName = 'Get Apigee Info API';
				const path = '/prod/proxies';
				const data = await Utils.fetchLambdaApis(apiName, path, null);
				this.setState({allProxies: data});
			} catch (error) {
				console.error('Error fetching proxies:', error);
			}
		}

		let proxies = this.state.allProxies;
		let matched = false;

		this.setState({proxyPathError: false});
		this.setState({usefulProxy: null})

		await proxies.forEach(p => {

            let virtualPathComparator = this.ammendStringAtEnd(virtualPath, "/");
            let targetPathComparator = this.ammendStringAtEnd(targetPath, "/");
            let proxyVirtualPathComparator = this.ammendStringAtEnd(p.virtualPath, "/");
            let proxyTargetPathComparator = this.ammendStringAtEnd(p.targetPath, "/");

	    	if(!matched && null != virtualPathComparator && virtualPathComparator.startsWith(proxyVirtualPathComparator)) {
	    		if(null != targetPathComparator && targetPathComparator.startsWith(p.targetPath + "/")) {
	    			let virtualPathRemainder = virtualPath.replace(proxyTargetPathComparator, '');
	    			let targetPathRemainder = targetPathComparator.replace(proxyTargetPathComparator, '');

	    			if((virtualPathComparator === proxyVirtualPathComparator && targetPathComparator === proxyTargetPathComparator)
						|| (virtualPathRemainder===targetPathRemainder)){
	    				matched = true;
	    				this.setState({proxyPathError: true});
                        this.setState({usefulProxy: p.name});
					}
	    		}
	    	}
	    });
	}

	ammendStringAtEnd = (base, value) => {
		if(null!= base && !base.endsWith(value)){
			return base + value;
		}
		return base;
	}

	getVariableFromString = (str) => {
		if(str.includes("{")&&str.includes("}")){
			if(str==="{}"){
				return " ";
			}
			return str.substring(str.indexOf("{") + 1, str.indexOf("}"));
		}
		return false;
	};

	validatePath = (path) => {
		let data = this.props.getStore();
		let match = disallowedPaths.find(r => path.match("^" + r + "$"));
		if(match){
			return path + " is a shared collection.";
		}

		let openTags = occurrences("{", path);
		let closeTags = occurrences("}", path);
		if (openTags !== closeTags) {
			return "Unbalanced number of opening '{' and closing '}' tags on " + path;
		}
		let splitPath = path.split("/");
		let m =[];
		for (let i = 0; i < splitPath.length; i++) {
			let str = this.getVariableFromString(splitPath[i]);
			if(str){
				m.push(str);
			}
		}

		let regExAlphaNumeric = "^[0-9a-zA-Z]+$";
		if(m !=null ) {
			for (let i = 0; i < m.length; i++) {
				if (!m[i].match(regExAlphaNumeric)) {
					return "Incorrect path variable {" + m[i] + "}. Must be alphanumeric.";
				}
			}
		}

		let doubleSlash = occurrences("//", path);
		if(doubleSlash > 0) {
			return "// not allowed on " + path;
		}

		let virtualPlaceholders = returnPlaceholders(data.virtualPath);
		let targetPlaceholders = returnPlaceholders(data.targetPath);
		if(!areSetsEqual(virtualPlaceholders, targetPlaceholders)) {
			return "Mismatched variable placeholders (" + [...virtualPlaceholders].join(", ") + ") vs. (" + [...targetPlaceholders].join(", ") + "). Variables can be in different orders, but must be present on both paths."
		}

		let asterisk = occurrences("\\*", path);
		if(asterisk > 0) {
			return "* not allowed on " + path + ". If you require a variable, use curly braces and a variable name, e.g. {contract}";
		}

	};

	validatePathVariables = (virtualPath, targetPath) => {

		let virtualOpenTags = occurrences("{", virtualPath);
		if(virtualOpenTags > 0 && targetPath == virtualPath && targetPath.startsWith("/retirement/v1")) {
			return "Target path is most likely incorrect and needs to begin with the application context root.\n"
				+ "If possible, another option is to simplify the virtual path to not contain any variables.";
		}
	};

	//lambda ensures correct 'this' scope
	onChange = (e) => {
		this.setState({
			proxyPathError: false,
			usefulProxy: null
		});
		let target = e.target.name;
		let value = e.target.value.replace(/\s/g, '');

		if(!value.startsWith('/')){
			value = '/' + value;
		}

		if(target === 'virtualPath' && this.props.getStore().virtualPath === this.props.getStore().targetPath) {
			this.props.updateStore({
				[target]: value,
				targetPath: value
			});
		} else {
			this.props.updateStore({
				[target]: value
			});
		}
	}

	render() {
		let data = this.props.getStore();
		let virtualPathError = this.validatePath(data.virtualPath);
		let targetPathError = this.validatePath(data.targetPath);

		if(!virtualPathError && !targetPathError) {
			targetPathError = this.validatePathVariables(data.virtualPath, data.targetPath);
		}

		return <div>
			<div className="container">
				<br/>
				<div className="row">

					<div className="col-md-6">
						<label htmlFor="virtualPath">Virtual Path:</label>
						<input className="form-control" id="virtualPath" name="virtualPath" value={data.virtualPath} onChange={this.onChange} />
						{virtualPathError && <p className="alert alert-danger util-margin-top-10">{virtualPathError}</p>}
					</div>
					<div className="col-md-6">
						<label htmlFor="targetPath" >Target Path:</label>
						<input className="form-control" id="targetPath" name="targetPath" value={data.targetPath} onChange={this.onChange} />
						{targetPathError && <p className="alert alert-danger util-margin-top-10">{targetPathError}</p>}
					</div>
				</div>
				<div className="row">
					<div className="col-md-12">
						{this.state.proxyPathError && <p className="alert alert-danger util-margin-top-10">The virtualPath and targetPath is already handled in an existing proxy, {this.state.usefulProxy}</p>}
					</div>
				</div>
				<br/>
			</div>
			<div className="container">
				<div className="row">
					<div className="col-md-6">
						<strong className="word-break-break-word" >https://api.theprincipal.net<span>{this.props.getStore().virtualPath}</span></strong>
					</div>
					<div className="col-md-6">
						<strong className="word-break-break-word" >{this.props.getStore().targetHost}<span>{this.props.getStore().targetPath}</span></strong>
					</div>
				</div>
				{data.environment === 'both' &&
				<div className="row">
					<div className="col-md-6">
						<strong className="word-break-break-word" >https://api.principal.com<span>{this.props.getStore().virtualPath}</span></strong>
					</div>
				</div>
				}
				<hr/>
				<div className="row">
					<div className="col-md-6 word-break-break-word">
						https://api.theprincipal.net<strong>{this.props.getStore().virtualPath}</strong>
					</div>
					<div className="col-md-6 word-break-break-word">
						{this.props.getStore().targetHost}<strong>{this.props.getStore().targetPath}</strong>
					</div>
				</div>
				<div className="row">
					<div className="col-md-6 word-break-break-word">
						https://api.theprincipal.net<strong>{this.props.getStore().virtualPath}</strong>/endpoint
					</div>
					<div className="col-md-6 word-break-break-word">
						{this.props.getStore().targetHost}<strong>{this.props.getStore().targetPath}</strong>/endpoint
					</div>
				</div>
				<div className="row">
					<div className="col-md-6 word-break-break-word">
						https://api.theprincipal.net<strong>{this.props.getStore().virtualPath}</strong>/node/endpoint
					</div>
					<div className="col-md-6 word-break-break-word">
						{this.props.getStore().targetHost}<strong>{this.props.getStore().targetPath}</strong>/node/endpoint
					</div>
				</div>
			</div>
		</div>
	}
}


export default RoutingLiberty;